export default __webpack_public_path__ + "static/cj-9cc43048bbfbdebb90a3c77c2f33cbf6.jpg";